var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.c_isShowObjQaFeedbackContent)?_c('div',[_c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v("追问")]),_c('p',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(" "+_vm._s(_vm.p_objQa.feedbackContent)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }